// accordions js start
document.addEventListener('DOMContentLoaded', function () {
 
  const headings = document.querySelectorAll('.accordion-heading');
  
  headings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      
      const contents = heading.nextElementSibling;
      
      if (contents.style.display === "none" || contents.style.display === "") {
        contents.style.display = "block";
        heading.classList.add('mian_active');  
      } else {
        contents.style.display = "none";
        heading.classList.remove('mian_active'); 
      }
    });
  });

  // Handle the accordion toggle for sub_accordint_contens
  function faq_taggol() {
    const accordions = document.querySelectorAll("[js-acc-item]");
    
    const openAccordion = (accordion) => {
      
      const content = accordion.querySelector("[js-acc-single-content]");
      accordion.classList.add("active");
      content.style.maxHeight = 'max-content';
      // setTimeout(function(){
      //    smoothScrollTo(content, 1000,400);
      // },1000);
    };
    
    const closeAccordion = (accordion) => {
      const content = accordion.querySelector("[js-acc-single-content]");
      accordion.classList.remove("active");
      if (content) {
        content.style.maxHeight = null;
      }
    };      

    accordions.forEach((accordion) => {
      const intro = accordion.querySelector("[js-acc-single-trigger]");
      const content = accordion.querySelector("[js-acc-single-content]");
      if (intro) {
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
      }
    });
  }

  faq_taggol();
});


// accordions js end

//scroll btn
let mybutton = document.getElementById("myBtn");
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
//endscroll btn

//demo-product-variant
document.querySelectorAll(".product-radio-item.variant_item").forEach(function(item) {
  item.addEventListener("click", function() {
    let currentTab = this.getAttribute('data-handle');
    document.querySelectorAll('.demo-right-product-content').forEach(function(content) {
        content.classList.add('hidden');
    });
    document.querySelectorAll('.demo-button').forEach(function(button) {
        button.classList.add('hidden');
    });
    document.querySelector('.demo-right-product-content[data-index="' + currentTab + '"]').classList.remove('hidden');
    document.querySelector('.demo-button[data-index="' + currentTab + '"]').classList.remove('hidden');
  });
});

//enddemo-product-variant

//add bundle set
document.addEventListener('DOMContentLoaded', function() {
  const productRadios = document.querySelectorAll('.product-checkbox');

  productRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      const selectedHandle = radio.closest('.variant_item').getAttribute('data-handles');

      document.querySelectorAll('.order-bulider-right-block').forEach(function(block) {
        block.classList.add('hidden');
      });
      // document.querySelectorAll('.pdp_buttons').forEach(function(button) {
      //   button.classList.add('hidden');
      //});

      const rightBlock = document.querySelector(`.order-bulider-right-block[data-indexs="${selectedHandle}"]`);
     // const pdpButton = document.querySelector(`.pdp_buttons[data-indexs="${selectedHandle}"]`);
      
      if (rightBlock) {
        rightBlock.classList.remove('hidden');
      }
      // if (pdpButton) {
      //   pdpButton.classList.remove('hidden');
      // }
    });
  });
});

//end add bundle set

//demo-product-overview
document.querySelectorAll(".product-overview-radio.product-radio-item").forEach(function(item) {
  item.addEventListener("click", function() {
    let currentTab = this.getAttribute('data-handles');
    document.querySelectorAll('.demo-product-overview-item').forEach(function(element) {
        element.classList.add('hidden');
    });
    document.querySelector('.demo-product-overview-item[data-indexs="' + currentTab + '"]').classList.remove('hidden');
  });
});

//enddemo-product-overview

//demo-test-kit
document.querySelectorAll(".product-radio-item.test_kit_radio").forEach(function(item) {
  item.addEventListener("click", function() {
    let currentTab = this.getAttribute('data-handles');        
    document.querySelectorAll('.kit-double-image').forEach(function(image) {
        image.classList.add('hidden');
    });
    document.querySelectorAll('.kit-button-block').forEach(function(button) {
        button.classList.add('hidden');
    });
    document.querySelector('.kit-double-image[data-indexs="' + currentTab + '"]').classList.remove('hidden');
    document.querySelector('.kit-button-block[data-indexs="' + currentTab + '"]').classList.remove('hidden');
  });
});
//enddemo-test-kit

 function cart_empty_addclclass(){
   const gift_popup = document.querySelector('.template-cart .cart__main-wrapper-block.is-empty') || null;
      if(document.querySelector('body').classList.contains('cart-is-empty')){
         document.querySelector('body').classList.remove('cart-is-empty');
      }
      if(gift_popup){
         document.querySelector('body').classList.add('cart-is-empty');
      }
  }


/*==== contact popup js ====*/

const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 

/*==== contact popup js ====*/

//Filter navigation

document.addEventListener('DOMContentLoaded', function() {
  const parentLinks = document.querySelectorAll('.parent-link');

  parentLinks.forEach(function(parentLink) {
    parentLink.addEventListener('click', function(e) {
      e.preventDefault(); 
      
      const subMenu = this.nextElementSibling;
      this.classList.toggle('active');
      
      if (subMenu && subMenu.classList.contains('sub-link')) {
        subMenu.classList.toggle('active');
      }
    });
  });

//   const childLinks = document.querySelectorAll('.child-link');

//   childLinks.forEach(function(childLink) {
//     childLink.addEventListener('click', function(e) {
//       e.preventDefault();
      
//       const grandchildMenu = this.nextElementSibling;
//       this.classList.toggle('active');
      
//       if (grandchildMenu && grandchildMenu.classList.contains('grandchild-link')) {
//         grandchildMenu.classList.toggle('active');
//       }
//     });
//   });
 });

//shop page collection tab
document.addEventListener('DOMContentLoaded', function() {
  const tabTitles = document.querySelectorAll('.tag-link-title');
  tabTitles.forEach(title => {
    title.addEventListener('click', function() {
      const tabHandle = this.getAttribute('data-handle');
      tabTitles.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const tabContents = document.querySelectorAll('.collection-tag-link-item');
      tabContents.forEach(content => content.classList.add('hidden'));
      tabContents.forEach(content => content.classList.remove('active'));
      const activeContent = document.querySelector(`.collection-tag-link-item[data-id="${tabHandle}"]`);
      if (activeContent) {
        activeContent.classList.remove('hidden');
        activeContent.classList.add('active');
      }
    });
  });
});



function smoothScrollTo(element, duration,scroll_hight) {
    const targetPosition = element.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Limit to 1 (100%)
        const ease = easeInOutCubic(progress); // Easing function
        window.scrollTo(0, (startPosition + distance * ease) - scroll_hight);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }

    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    requestAnimationFrame(animation);
}


document.addEventListener('DOMContentLoaded', function () {
  
  const vatField = document.getElementById('vat-field');
  const vatInput = document.getElementById('vat_number');
  const errorMsg = document.querySelector('.vat-error');
  const checkoutBtn = document.querySelector('button[name="checkout"]');

  function checkCountry() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const isAustria = document.body.innerHTML.includes('Austria') || 
                          document.body.innerHTML.includes('Österreich');

        if (isAustria) {
          vatField.style.display = 'block';
        } else {
          vatField.style.display = 'none';
          errorMsg.style.display = 'none';
        }
      });
  }

  checkCountry();

  // Checkout validation
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      
      const isVisible = vatField.style.display === 'block';

      if (isVisible && vatInput.value.trim() === '') {
        e.preventDefault();
        errorMsg.style.display = 'block';
        vatInput.focus();
      }
    });
  }

});
document.getElementById('vat_number').addEventListener('change', function () {
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        "VAT Number": this.value
      }
    })
  });

});

//country load more  & search country

document.addEventListener("DOMContentLoaded", function () {

  const loadMoreBtn = document.querySelector(".luna_more");
  const searchInput = document.querySelector('[id^="country-search-"]');
  const allCountries = document.querySelectorAll(".country_text_block");

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {

      allCountries.forEach(item => {
        item.style.display = "block";
        item.classList.remove("hidden-country");
      });

      loadMoreBtn.style.display = "none";
    });
  }

  if (searchInput) {
    searchInput.addEventListener("keyup", function () {

      let value = this.value.toLowerCase();

      allCountries.forEach(item => {
        let countryName = item.querySelector(".title").textContent.toLowerCase();

        if (countryName.includes(value)) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });

      if (value.length > 0 && loadMoreBtn) {
        loadMoreBtn.style.display = "none";
      } 
      else {
        allCountries.forEach((item, index) => {
          if (index < 9) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
            item.classList.add("hidden-country");
          }
        });

        if (loadMoreBtn && allCountries.length > 9) {
          loadMoreBtn.style.display = "inline-block";
        }
      }

    });
  }

});
